import styled from '@emotion/styled';
import { breakpoint } from '@styles/breakpoints';

export const Form = styled.form`
  height: 100%;
  width: 100%;

  label[for='input_message-text'] {
    display: none;
  }

  textarea {
    width: 100%;
    resize: none;
    height: 200px;
    padding: 16px;
    font-family: ${({ theme }) => theme.defaults.fontFamily.primary};
  }

  .custom-control {
    margin-bottom: 24px;
  }

  button[type='submit'] {
    width: calc(50% - 48px);
    margin: 56px 0 32px 0;
  }

  @media only screen and ${breakpoint.md} {
    & textarea {
      margin-top: 30px;
    }

    & button[type='submit'] {
      width: 100%;
    }
  }

  @media only screen and ${breakpoint.sm} {
    & input[type='checkbox'] {
      margin-right: 16px;
    }
  }
`;

export const InputsContainer = styled.div`
  display: flex;
  grid-column-gap: 48px;

  @media only screen and ${breakpoint.md} {
    display: block;

    div {
      margin-bottom: 20px;
    }
  }
`;

export const CaptchaContainer = styled.div`
  margin-top: 30px;

  width: desired_width;

  border-radius: 4px;
  border-right: 1px solid #d8d8d8;
  overflow: hidden;

  /* & .g-recaptcha {
    transform: scale(0.77);
    transform-origin: 0 0;
  } */
`;
